import { Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/Router/paths';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { VoiceChannelMember } from 'src/provider/VoiceChannel';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import {
  GoBackNavButton,
  TakingNotesStyled,
  TopRightIconsStyled,
} from './styles';
import { useMemberVariables } from './useMemberVariables';

type Props = {
  member: VoiceChannelMember;
  isFromNav: boolean;
  connected: boolean;
  aloneMember: boolean;
};

export const TopAbsoluteButtons = ({
  member,
  isFromNav,
  connected,
  aloneMember,
}: Props) => {
  const navigate = useNavigate();
  const { translate } = useLocales();

  const { activeVoiceChannel } = useLivekitRTCState();

  const { startedByCurrentMember } = useMemberVariables({
    member,
    connected,
    aloneMember,
  });

  const handleNavigateToChannel = () =>
    navigate(PATH_DASHBOARD.chat.view(activeVoiceChannel.channel._id));

  return (
    <>
      <TopRightIconsStyled className="top-right-icons">
        {member.playedSound && <em-emoji shortcodes={member.playedSound} />}
        {member.raisedHand && (
          <Iconify icon="tabler:hand-stop" color="warning.main" />
        )}
        {startedByCurrentMember && (
          <TakingNotesStyled>
            <Iconify icon="tabler:file-text" width="16" height="16" />
            <Typography variant="caption" color="text.primary">
              {translate('communicate.gathering.is_taking_notes')}
            </Typography>
          </TakingNotesStyled>
        )}
      </TopRightIconsStyled>
      {isFromNav && (
        <GoBackNavButton
          onClick={handleNavigateToChannel}
          className="go-back-button"
        >
          <Iconify
            icon="tabler:arrow-left"
            width="16"
            height="16"
            color="white"
          />
          <Typography variant="caption" color="white">
            {translate('shared.buttons.go_back')}
          </Typography>
        </GoBackNavButton>
      )}
    </>
  );
};
